import 'rc-dropdown/assets/index.css'
import 'rc-menu/assets/index.css'
import {Route, Routes, useLocation} from 'react-router-dom'
import Style from './style'

import {
	InitPageQueryRouter,
	InitProGradeQueryRouter,
	PrivateRoute,
	ProtectRoute,
	PublicRoute,
	StartPageRouter,
} from './lib/conditionalRouter'
import InternalServerError from './ui/InternalServerError'
import NotFound from './ui/NotFound'

// === 로그인 관련 페이지
import FindAdminId from './ui/FindAdminId'
import FindAdminPw from './ui/FindAdminPw'
import FindManagerId from './ui/FindManagerId'
import FindManagerPw from './ui/FindManagerPw'
import LoginAdmin from './ui/LoginAdmin'
import LoginManager from './ui/LoginManager'
import SignupAdmin from './ui/SignupAdmin'

// === 프랜차이즈 매니저, 지점 매니저의 페이지
import MyEventList from './ui/MyEventList'
import MyFranchise from './ui/MyFranchise'
import MyFranchiseEdit from './ui/MyFranchiseEdit'
import MyFranchiseManagerTicketList from './ui/MyFranchiseManagerTicketList'
import MyFranchiseMemberTicketList from './ui/MyFranchiseMemberTicketList'
import MyFranchiseTicketTransactionHistory from './ui/MyFranchiseTicketTransactionHistory'
import MyStore from './ui/MyStore'
import MyStoreEdit from './ui/MyStoreEdit'

// === 관리자의 페이지

import MyAdminEdit from './ui/MyAdminEdit'

// 회원 관리
import AdminList from './ui/AdminList'
import FranchiseManagerCreate from './ui/FranchiseManagerCreate'
import FranchiseManagerDetail from './ui/FranchiseManagerDetail'
import FranchiseManagerList from './ui/FranchiseManagerList'
import StoreManagerDetail from './ui/StoreManagerDetail'
import UserDetail from './ui/UserDetail'
import UserList from './ui/UserList'

// 대회 시리즈 관리
import SeriesCreate from './ui/SeriesCreate'
import SeriesDetail from './ui/SeriesDetail'
import SeriesEdit from './ui/SeriesEdit'
import SeriesList from './ui/SeriesList'
import SeriesSeedTemplate from './ui/SeriesSeedTemplate'

// 대회 관리
import EventCreate from './ui/EventCreate'
import EventDetail from './ui/EventDetail'
import EventEdit from './ui/EventEdit'
import EventList from './ui/EventList'
import EventParticipantList from './ui/EventParticipantList'
import EventParticipantTemplate from './ui/EventParticipantTemplate'
import EventQr from './ui/EventQr'
import QrScanStore from './ui/QrScanStore'
import QrScanTour from './ui/QrScanTour'
import ScanType from './ui/ScanType'

// 칼럼 관리
import AdCreate from './ui/AdCreate'
import AdDetail from './ui/AdDetail'
import AdEdit from './ui/AdEdit'
import AdList from './ui/AdList'
import MediaCreate from './ui/MediaCreate'
import MediaEdit from './ui/MediaEdit'
import MediaList from './ui/MediaList'
import NoticeCreate from './ui/NoticeCreate'
import NoticeDetail from './ui/NoticeDetail'
import NoticeEdit from './ui/NoticeEdit'
import NoticeList from './ui/NoticeList'
import YoutubeCreate from './ui/YoutubeCreate'
import YoutubeEdit from './ui/YoutubeEdit'
import YoutubeList from './ui/YoutubeList'

// 타이머 광고 관리
import AdTimerCreate from './ui/AdTimerCreate'
import AdTimerEdit from './ui/AdTimerEdit'
import AdTimerList from './ui/AdTimerList'

// 타이머 데모
import TimerDemo from './ui/TimerDemo'

// 트라이아웃 관리
import TryoutExamCreate from './ui/TryoutExamCreate'
import TryoutExamDetail from './ui/TryoutExamDetail'
import TryoutExamList from './ui/TryoutExamList'
import TryoutPtPayList from './ui/TryoutPtPayList'
import TryoutWtPayList from './ui/TryoutWtPayList'

// 사용자 티켓현황
import JoinTicketStatus from './ui/JoinTicketStatus'
import SeedTicketLog from './ui/SeedTicketLog'
import SeedTicketStatus from './ui/SeedTicketStatus'

import useLogoutEvent from 'app/ui/Aside/model/useLogoutEvent'
import {useEffect, useState} from 'react'
import {
	ROLE_COMPETITION_MANAGER,
	ROLE_EVENT_ADMIN,
	ROLE_EXTERNAL_ADMIN,
	ROLE_FIELD_MANAGER,
	ROLE_FRANCHISE_MANAGER,
	ROLE_MARKETING_ADMIN,
	ROLE_SITE_ADMIN,
	ROLE_STORE_ADMIN,
	ROLE_STORE_MANAGER,
	ROLE_SUPER_ADMIN,
	ROLE_TIMER_MANAGER,
} from 'shared/constant/lookup/role'
import SubManagerList from './ui/CompetitionManagerList'
import Maintenance from './ui/Maintenance'
import MyBranch from './ui/MyBranch'
import MyBranchEdit from './ui/MyBranchEdit'
import MyFranchiseStoreCreate from './ui/MyFranchiseStoreCreate'
import MyFranchiseStoreList from './ui/MyFranchiseStoreList'
import MyFranchiseTicket from './ui/MyFranchiseTicket'
import MyFranchiseTicketEdit from './ui/MyFranchiseTicketEdit'
import MyFranchiseTicketPossessionDetail from './ui/MyFranchiseTicketPossessionDetail'
import SubAdminDetail from './ui/SubAdminDetail'
import SubManagerCreate from './ui/SubManagerCreate'
import TryoutExamVersionList from './ui/TryoutExamVersionList'
import EventTimerParticipant from './ui/EventTimerParticipant'
import TimerPreview from './ui/TimerPreview'

const Router = () => {
	const [, logout] = useLogoutEvent()
	const [isMaintenance, setIsMaintenance] = useState(
		process.env.REACT_APP_MAINTENANCE === 'true'
	)

	useEffect(() => {
		if (isMaintenance) {
			logout()
		}
	}, [])

	const {pathname} = useLocation()

	if (pathname.startsWith('/event/timer-preview')) {
		return (
			<Routes>
				<Route path='/event/timer-preview' element={<TimerPreview />} />
			</Routes>
		)
	}

	return (
		<Style.Main>
			<Routes>
				{isMaintenance ? (
					<Route
						path='/'
						element={<Maintenance setIsMaintenance={setIsMaintenance} />}
					/>
				) : (
					<>
						{/* 비로그인 */}
						<Route element={<PublicRoute />}>
							{/* <Route element={<InitPageQueryRouter />}>
								<Route path='/signup/manager' element={<SignupManager />} />
							</Route> */}
							<Route path='/login/manager' element={<LoginManager />} />
							<Route path='/find/manager/id' element={<FindManagerId />} />
							<Route
								path='/find/manager/password'
								element={<FindManagerPw />}
							/>
							<Route path='/find/admin/id' element={<FindAdminId />} />
							<Route path='/find/admin/password' element={<FindAdminPw />} />
							<Route path='/login/admin' element={<LoginAdmin />} />
							<Route path='/signup/admin' element={<SignupAdmin />} />
						</Route>

						{/* 로그인 */}
						<Route element={<PrivateRoute />}>
							<Route index element={<StartPageRouter />} />

							<Route path='/admin/my/edit' element={<MyAdminEdit />} />

							{/* 최고 관리자 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_SUPER_ADMIN,
											ROLE_COMPETITION_MANAGER,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route path='/admin' element={<AdminList />} />
									<Route element={<InitProGradeQueryRouter />}>
										<Route path='/exam' element={<TryoutExamList />} />
										<Route
											path='/exam/:idx/version'
											element={<TryoutExamVersionList />}
										/>
										<Route
											path='/exam/me'
											element={<TryoutExamVersionList />}
										/>
										<Route
											path='/exam/:idx/detail'
											element={<TryoutExamDetail />}
										/>
									</Route>
									<Route path='/wt-pay/list' element={<TryoutWtPayList />} />
									<Route path='/pt-pay/list' element={<TryoutPtPayList />} />

									<Route
										path='/exam/:idx/detail'
										element={<TryoutExamDetail />}
									/>
									<Route path='/ad-timer' element={<AdTimerList />} />
								</Route>
								<Route
									path='/exam/:idx/create'
									element={<TryoutExamCreate />}
								/>
								<Route path='/ad-timer/create' element={<AdTimerCreate />} />
								<Route path='/ad-timer/:idx/edit' element={<AdTimerEdit />} />
							</Route>

							{/* 최고 관리자 & 마케팅 관리자 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_SUPER_ADMIN,
											ROLE_MARKETING_ADMIN,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route path='/notice' element={<NoticeList />} />
									<Route path='/ad' element={<AdList />} />
									<Route path='/youtube' element={<YoutubeList />} />
									<Route path='/media' element={<MediaList />} />
								</Route>
								<Route path='/notice/:idx/detail' element={<NoticeDetail />} />
								<Route path='/notice/create' element={<NoticeCreate />} />
								<Route path='/notice/:idx/edit' element={<NoticeEdit />} />
								<Route path='/ad/:idx/detail' element={<AdDetail />} />
								<Route path='/ad/create' element={<AdCreate />} />
								<Route path='/ad/:idx/edit' element={<AdEdit />} />
								<Route path='/youtube/create' element={<YoutubeCreate />} />
								<Route path='/youtube/:idx/edit' element={<YoutubeEdit />} />
								<Route path='/media/create' element={<MediaCreate />} />
								<Route path='/media/:idx/edit' element={<MediaEdit />} />
							</Route>

							{/* 최고 관리자 & 매장 관리자 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[ROLE_SUPER_ADMIN, ROLE_STORE_ADMIN]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route
										path='/manager/franchise'
										element={<FranchiseManagerList />}
									/>
								</Route>
								<Route
									path='/manager/franchise/:idx/detail'
									element={<FranchiseManagerDetail />}
								/>
								<Route
									path='/manager/franchise/create'
									element={<FranchiseManagerCreate />}
								/>
							</Route>

							{/* SUB MANAGER*/}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[ROLE_COMPETITION_MANAGER]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route
										path='/manager/sub-manager'
										element={<SubManagerList />}
									/>
								</Route>
								<Route
									path='/manager/sub-manager/:idx/detail'
									element={<SubAdminDetail />}
								/>
								<Route
									path='/manager/sub-manager/create'
									element={<SubManagerCreate />}
								/>
							</Route>

							{/* 최고 관리자 & 대회 관리자 & 외부 관리자 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_SUPER_ADMIN,
											ROLE_EVENT_ADMIN,
											ROLE_EXTERNAL_ADMIN,
											ROLE_COMPETITION_MANAGER,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route path='/user' element={<UserList />} />
									<Route path='/user/:idx/detail' element={<UserDetail />} />
								</Route>
								<Route path='/series/create' element={<SeriesCreate />} />
								<Route path='/series/:idx/edit' element={<SeriesEdit />} />
								<Route
									path='/series/seed-template'
									element={<SeriesSeedTemplate />}
								/>
							</Route>

							{/* 최고 관리자 & 매장 관리자 & 프랜차이즈 매니저 */}

							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_SUPER_ADMIN,
											ROLE_STORE_ADMIN,
											ROLE_FRANCHISE_MANAGER,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route
										path='/list/store/:idx/detail'
										element={<StoreManagerDetail />}
									/>
								</Route>
								<Route element={<InitPageQueryRouter />}>
									<Route
										path='/manager/store/:idx/detail'
										element={<StoreManagerDetail />}
									/>
								</Route>
							</Route>

							{/* 최고 관리자 & 매장 관리자 & 대회 관리자 & 외부 관리자 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_SUPER_ADMIN,
											ROLE_STORE_ADMIN,
											ROLE_EVENT_ADMIN,
											ROLE_EXTERNAL_ADMIN,
											ROLE_COMPETITION_MANAGER,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route path='/series' element={<SeriesList />} />
									<Route
										path='/series/:idx/detail'
										element={<SeriesDetail />}
									/>
								</Route>
							</Route>

							{/* 프랜차이즈 매니저 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_FRANCHISE_MANAGER,
											ROLE_COMPETITION_MANAGER,
										]}
									/>
								}
							>
								<Route path='/manager/my/edit' element={<MyFranchiseEdit />} />
							</Route>

							{/* COMPLETITION MANAGER */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_COMPETITION_MANAGER,
											ROLE_FIELD_MANAGER,
											ROLE_TIMER_MANAGER,
										]}
									/>
								}
							>
								<Route path='/sub-manager/manage' element={<MyBranch />} />
								<Route
									path='/sub-manager/manage/edit'
									element={<MyBranchEdit />}
								/>
							</Route>

							{/* 프랜차이즈 매니저 & 지점 매니저 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_FRANCHISE_MANAGER,
											ROLE_STORE_MANAGER,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route path='/store/my' element={<MyStore />} />
									<Route path='/event/my' element={<MyEventList />} />
									<Route
										path='/ticket-member'
										element={<MyFranchiseMemberTicketList />}
									/>
								</Route>
								<Route path='/manager/my' element={<MyFranchise />} />
								<Route path='/list/store' element={<MyFranchiseStoreList />} />

								<Route path='/store/my/edit' element={<MyStoreEdit />} />
								<Route path='/ticket' element={<MyFranchiseTicket />} />
								<Route
									path='/ticket-manager/transaction-history'
									element={<MyFranchiseTicketTransactionHistory />}
								/>
								<Route
									path='/ticket-manager/edit'
									element={<MyFranchiseTicketEdit />}
								/>
								<Route
									path='/ticket-manager/store/:idx/detail'
									element={<MyFranchiseTicketPossessionDetail />}
								/>
								<Route
									path='/ticket-manager'
									element={<MyFranchiseManagerTicketList />}
								/>
							</Route>
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_FIELD_MANAGER,
											ROLE_TIMER_MANAGER,
										]}
									/>
								}
							>
								<Route
									path='/account'
									element={<MyFranchiseManagerTicketList />}
								/>
							</Route>
							<Route
								element={
									<ProtectRoute permissionRoleList={[ROLE_FRANCHISE_MANAGER]} />
								}
							>
								<Route
									path='/list/store/create'
									element={<MyFranchiseStoreCreate />}
								/>
							</Route>

							{/* 최고 관리자 & 대회 관리자 & 현장 관리자 & 프랜차이즈 매니저 & 지점 매니저 & 외부 관리자 */}
							<Route
								element={
									<ProtectRoute
										permissionRoleList={[
											ROLE_SUPER_ADMIN,
											ROLE_EVENT_ADMIN,
											ROLE_SITE_ADMIN,
											ROLE_FRANCHISE_MANAGER,
											ROLE_STORE_MANAGER,
											ROLE_EXTERNAL_ADMIN,
											ROLE_COMPETITION_MANAGER,
											ROLE_FIELD_MANAGER,
											ROLE_TIMER_MANAGER,
										]}
									/>
								}
							>
								<Route element={<InitPageQueryRouter />}>
									<Route path='/event' element={<EventList />} />
									<Route
										path='/event/:idx/participant'
										element={<EventParticipantList />}
									/>
									<Route
										path='/event/:idx/participant-template'
										element={<EventParticipantTemplate />}
									/>
									<Route path='/event/:idx/detail' element={<EventDetail />} />
									<Route path='/event/create' element={<EventCreate />} />
									<Route path='/event/:idx/edit' element={<EventEdit />} />
								</Route>
								<Route path='/event/:idx/qr' element={<EventQr />} />
								<Route path='/scan-type' element={<ScanType />} />
								<Route path='/qr-scan/tournament' element={<QrScanTour />} />
								<Route path='/qr-scan/store' element={<QrScanStore />} />
								<Route path='/event/:idx/timer-demo' element={<TimerDemo />} />
								<Route
									path='/event/:idx/timer/participant'
									element={<EventTimerParticipant />}
								/>
							</Route>
						</Route>

						{/* @Desc 티켓 보유현황 */}
						<Route path='/seed-ticket-status' element={<SeedTicketStatus />} />
						<Route path='/seed-ticket-log' element={<SeedTicketLog />} />
						<Route path='/join-ticket-status' element={<JoinTicketStatus />} />
						{/* 상관 없음 */}
						<Route path='/500' element={<InternalServerError />} />
					</>
				)}

				<Route path='*' element={<NotFound />} />
			</Routes>
		</Style.Main>
	)
}

export default Router
